import { cardViewStyle } from 'prose-core'
import { Command } from './types'

export const updateCardStyle = (nodePos: number, cardStyle: cardViewStyle): Command => {
  return (state, dispatch) => {
    const { tr } = state
    const node = tr.doc.nodeAt(nodePos)
    if (node) {
      tr.setNodeMarkup(nodePos, undefined, {
        ...node.attrs,
        cardStyle,
      })
      dispatch?.(tr)
      return true
    }
    return false
  }
}
